{
  "home.cards.empty": "Ei kortteja näytettävänä juuri nyt.",
  "home.cards.errorState": "Korttien lataus epäonnistui.",
  "home.cards.loading": "Ladataan kortteja…",
  "home.feedback.close": "Sulje",
  "home.feedback.error": "Palautteen lähettäminen epäonnistui. Yritä uudelleen.",
  "home.feedback.description": "Anna arvosana ja vapaamuotoinen palaute",
  "home.feedback.edgeMax": "Erittäin tyytyväinen",
  "home.feedback.edgeMin": "Erittäin tyytymätön",
  "home.feedback.label": "Palaute",
  "home.feedback.legend": "Anna arvosana 1–5",
  "home.feedback.ratingLabel": "Arvosana {n}",
  "home.feedback.submit": "Lähetä",
  "home.feedback.submitPending": "Lähetetään…",
  "home.feedback.success": "Kiitos palautteestasi",
  "home.feedback.textareaLabel": "Vapaa palaute",
  "home.feedback.textareaPlaceholder": "Jättämällä meille palautetta, autat meitä parantamaan palveluitamme",
  "home.feedback.title": "Anna palautetta",
  "home.greeting.anonymous": "Tervetuloa",
  "home.greeting.day": "Hyvää päivää,",
  "home.greeting.evening": "Hyvää iltaa,",
  "home.greeting.morning": "Hyvää huomenta,",
  "home.overdueFee.title": "Jäsenmaksusi on erääntynyt",
  "home.overdueFee.body": "Jäsenmaksusi on vielä maksamatta, vaikka eräpäivä on mennyt. Jos olet jo maksanut, maksun kirjautuminen voi kestää muutaman pankkipäivän.",
  "home.overdueFee.action": "Siirry jäsenmaksuihin",
  "home.quickAccess.contact.subtitle": "Työsuhde- tai palkkapulmia? Kysymys jäsenyydestä?",
  "home.quickAccess.contact.title": "Ota yhteyttä",
  "home.quickAccess.deferredBadge": "Tulossa",
  "home.quickAccess.lakiruutu.subtitle": "Lakiruutu-videoista lakiapua työsuhdeasioihin",
  "home.quickAccess.lakiruutu.title": "Lakiruutu käytössäsi",
  "home.quickAccess.tools.subtitle": "Hyödylliset työkalut ja laskurit tukenasi",
  "home.quickAccess.tools.title": "Työkalut ja laskurit",
  "home.tabs.label": "Etusivun osiot",
  "home.tabs.lakikaveri": "Lakikaveri",
  "home.tabs.palvelutEdut": "Jäsenyys ja edut"
}
